module.exports = __webpack_public_path__ + "media/application/images/icons/icon-progress-7adc27cebfb221500999ef74fadf9593.svg";